import { h, Host } from "@stencil/core";
import { configureSlider } from "../abstract-uvex-slider/configure-slider";
export class SliderNavIcons {
    componentDidLoad() {
        this.swiper = configureSlider(this.el, {
            loop: false,
            pagination: false,
            slidesPerView: 2,
            slidesPerGroup: 2,
            breakpoints: {
                543: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                767: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                991: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
            },
        });
    }
    disconnectedCallback() {
        if (this.swiper) {
            this.swiper.destroy();
        }
    }
    render() {
        return h(Host, { key: 'ccb76bfdf3d2fb90f47399faa1c0af0996bbea74', class: "carousel no-carousel-bottom-spacing" }, h("div", { key: '880b0dca83b66ce74d6bacaa94ac8af84b4ea027', class: "carousel-inner" }, h("slot", { key: 'ab595932f7b1d27c90b3c41476021d6301cfb223' })), h("a", { key: 'd757786bc3978c9ea8b19b5a8c4f9fea686bf6d8', class: "carousel-control carousel-control-left small invert left", role: "button" }), h("a", { key: '8c2fc7bfdebb5cc1134854758d4cdace3536c8eb', class: "carousel-control carousel-control-right small invert right", role: "button" }), h("ol", { key: 'd388f8105249faa8c7939be8051abd87be446de0', class: "carousel-indicators" }));
    }
    static get is() { return "uvex-slider-nav-icons"; }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=slider-nav-icons.js.map
